// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EC_AT","houseContainer":"styles_houseContainer__8NwBV"};